import { UsersDetailsGroupsTab } from "./UsersDetailsGroupsTab";

export default UsersDetailsGroupsTab;
